<template>
    <div>
        <div class="container container-mob " >
            <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад" class="mr-2">
                <img width="40px" src="/static/images/icons/left-arrow.svg">
            </b-button>
        </div>
        <div class="container">
            <b-carousel
                    id="carousel-1"
                    v-model="slide"
                    :interval="4000"
                    controls
                    indicators
                    background="#ababab"
                    class="object_corousel"
                    img-width="1024"
                    img-height="380"
                    style="text-shadow: 1px 1px 2px #333; "
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
            >
                <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
                <b-carousel-slide v-if="!photos.length"  img-src="/static/images/no_image.jpg"  ></b-carousel-slide>
                <b-carousel-slide v-else  v-for="ph in photos" :key="ph.id">
                    <template v-slot:img>
                        <img
                                class="d-block img-fluid w-100"
                                width="1024"
                                height="480"
                                :src="'/static/uploads/'+ph.photo"
                                alt="image slot"
                        >
                    </template>
                </b-carousel-slide>
            </b-carousel>
        </div>
        <div class="container pt-2">
            <div class="row ">
                <div class="text-center col-lg-12">
                    <h2 class="font-weight-bold">{{object['title_'+selectedLocale.suffix.toLowerCase()]}}</h2>
<!--                    <h2 class="font-weight-bold" v-if="object.category != 4">№ {{object.number}} </h2>-->
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.city')}}</b>
                </div>
                <div class="col-6">
                    {{object['city_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.district')}}</b>
                </div>
                <div class="col-6">
                    {{object['region_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr/>
            <div class="row " v-if="object.category != 4">
                <div class="col-6">
                    <b>{{$t('message.legal_address')}}</b>
                </div>
                <div class="col-6">
                    {{object['address_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr v-if="object.category != 4"/>
            <div class="row " v-if="object.category != 4">
                <div class="col-6">
                    <b>{{$t('message.total_area')}}</b>
                </div>
                <div class="col-6">
                    {{object['totalArea']}}
                </div>
            </div>
            <hr v-if="object.category != 4"/>
            <div class="row " v-if="object.category != 4">
                <div class="col-6">
                    <b>{{$t('message.building_area')}}</b>
                </div>
                <div class="col-6">
                    {{object['buildingArea']}}
                </div>
            </div>
            <hr v-if="object.category != 4"/>
            <div class="row " v-if="object.category != 4">
                <div class="col-6">
                    <b>{{$t('message.used_area')}}</b>
                </div>
                <div class="col-6">
                    {{object['usedArea']}}
                </div>
            </div>
            <hr v-if="object.category != 4"/>
            <div class="row " v-if="object.category != 4">
                <div class="col-6">
                    <b>{{$t('message.free_land_area')}}</b>
                </div>
                <div class="col-6">
                    {{object['freeArea']}}
                </div>
            </div>
            <hr v-if="object.category != 4"/>
            <div class="row ">
                <div class="col-6">
                    <b v-if="object.category != 4">{{$t('message.problems')}}</b>
                    <b v-else>{{$t('message.titleProblem')}}</b>
                </div>
                <div class="col-6" v-html="object['problems_'+selectedLocale.suffix.toLowerCase()]"></div>
            </div>
            <hr/>
            <div class="row " v-if="object.status==='active'">
                <div class="col-6">
                    <b>{{$t('message.expDate')}}</b>
                </div>
                <div class="col-6">
                    {{object['dateExp']}}
                </div>
            </div>
            <hr v-if="object.status==='active'"/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.status')}}</b>
                </div>
                <div class="col-6">
                    {{$t('message.'+object.status+'_1')}}
                </div>
            </div>
        </div>
        <div class="container mt-5 yandex-iframe" >
            <div v-html="object.map"></div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {getObjectsById} from '../api/index'

    export default {
        name: 'privet-schools',
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        data() {
            return {
                slide: 0,
                sliding: null,
                object: {},
                photos: [],
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            },
            getData() {
                getObjectsById(this.$route.params.id).then(res => {
                    this.object = res.data.object[0]
                    this.photos = res.data.photos
                })
            }
        }
    }
</script>

<style>
.object_corousel .carousel-item {
    max-height: 480px !important;
}
.object_corousel img {
    vertical-align: middle !important;
}
    .yandex-iframe iframe {
        width: 100% !important;
        height: 294px !important;
    }
.container-mob {
    padding-top: 100px;
    display: flex;
}
</style>
